import React, { useState } from 'react';
import { useService } from 'hooks';
import useArnService from 'services/arnService/useArnService';
import {
  IGetArnReferenceDataRequest,
  IGetArnReferenceDataResponse,
  IHasArnOrPendingSubmissionResponse
} from 'services/arnService/arnServiceTypes';

const getCountryListRequest: IGetArnReferenceDataRequest = {
  type: ['Country'],
  code: ['Country', 'Nationality']
};

interface IArnContextType {
  referenceDataResponse?: IGetArnReferenceDataResponse | null | undefined;
  arnType: string;
  previousStep: string;
  isArnApplicationSubmitted: boolean;
  hasArnOrPendingSubmissionResponse?: IHasArnOrPendingSubmissionResponse | null | undefined;
  setPreviousStep: (stepId: string) => void;
  setArnType: (type: string) => void;
  setArnApplicationSubmitted: (isSubmitted: boolean) => void;
}

export const ArnContext = React.createContext<IArnContextType>({} as IArnContextType);

export const ArnContextProvider: React.FC = ({ children }) => {
  const [arnType, setArnType] = useState<string>('');
  const [previousStep, setPreviousStep] = useState<string>('');
  const [arnSubmitted, setArnSubmitted] = useState<boolean>(false);
  const arnService = useArnService();
  const referenceDataResponse = useService<IGetArnReferenceDataResponse>(() => arnService.getArnReferenceData(getCountryListRequest));
  const hasArnOrPendingSubmissionResponse = useService<IHasArnOrPendingSubmissionResponse>(() => arnService.getHasArnOrPendingSubmissionResponse());
  const setArnApplicationSubmitted = (isSubmitted: boolean) => {
    setArnSubmitted(isSubmitted);
  };

  const setArnApplicationType = (type: string) => {
    setArnType(type);
  };

  const setApplicationPerviousStep = (stepId: string) => {
    setPreviousStep(stepId);
  };
  return (
    <ArnContext.Provider value={{
      referenceDataResponse: referenceDataResponse,
      arnType: arnType,
      previousStep: previousStep,
      isArnApplicationSubmitted: arnSubmitted,
      hasArnOrPendingSubmissionResponse: hasArnOrPendingSubmissionResponse,
      setArnType: setArnApplicationType,
      setPreviousStep: setApplicationPerviousStep,
      setArnApplicationSubmitted: setArnApplicationSubmitted
    }}>
      {children}
    </ArnContext.Provider>
  );
};